<template>
  <div class="featured-programs" :aria-busy="loading">
      <div v-if="loading" class="market-state" role="status">
        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
        <p>Eğitimler yükleniyor…</p>
      </div>
      <div v-else-if="loadError" class="market-state" role="alert">
        <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
        <h2>Eğitimler şu anda yüklenemedi.</h2>
        <p>Lütfen biraz sonra tekrar dene.</p>
        <button type="button" class="retry-button" @click="getCategories">Tekrar dene</button>
      </div>
      <div v-else-if="!categoryCards.length" class="market-state">
        <i class="bi bi-book" aria-hidden="true"></i>
        <h2>Şu anda listelenecek eğitim bulunmuyor.</h2>
        <p>Eğitim seçeneklerini görmek için daha sonra tekrar uğra.</p>
      </div>
      <section v-else class="market-grid" aria-label="Eğitim seçenekleri">
        <router-link v-for="category in categoryCards" :key="category.id"
          :to="{ name: 'MarketDetail', params: { id: category.id }, query: { campaingcode: CampaingCode } }"
          class="education-card">
          <div class="education-image">
            <img v-if="category.image" :src="category.image" alt="" loading="lazy" decoding="async" width="960" height="480">
            <i v-else class="bi bi-book" aria-hidden="true"></i>
          </div>
          <div class="education-body">
            <h2>{{ category.categoryName }}</h2>
            <p v-if="category.details.summaryDescription" class="education-description">{{ category.details.summaryDescription }}</p>
            <div class="education-meta">
              <div v-if="category.details.level.length" class="education-levels" aria-label="Eğitim seviyeleri">
                <span v-for="level in category.details.level" :key="level">{{ level }}</span>
              </div>
              <span v-if="category.details.lessonCount !== ''" class="lesson-count">
                <i class="bi bi-collection-play" aria-hidden="true"></i>{{ category.details.lessonCount }} ders
              </span>
            </div>
            <div class="education-action"><span>Eğitimi incele</span><i class="bi bi-arrow-right" aria-hidden="true"></i></div>
          </div>
        </router-link>
      </section>
  </div>
</template>

<script>
import { mapActions } from 'vuex';


import { GetCategoryProperty } from '@/common/market-helper';
import { getMarketImage } from '@/common/market-image';

export default {
  name: 'FeaturedPrograms',

  data() {
    return { categories: [], loading: true, loadError: false };
  },
  computed: {
    CampaingCode() {
      return this.$route.query.campaingcode || '';
    },
    categoryCards() {
      return this.categories.map(category => {
        const details = GetCategoryProperty(category.properties);
        const image = getMarketImage(details);
        return { ...category, details, image };
      });
    }
  },
  methods: {
    ...mapActions(['GetFeaturedPrograms']),
    async getCategories() {
      this.loading = true;
      this.loadError = false;
      try {
        this.categories = await this.GetFeaturedPrograms();
      } catch {
        this.loadError = true;
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.getCategories();
  }
};
</script>

<style scoped>
.featured-programs { margin-top: 24px; color: #253545; }
.market-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(min(100%, 260px), 1fr)); gap: 24px; }
.education-card { display: flex; flex-direction: column; min-width: 0; overflow: hidden; border: 1px solid #e0e6ed; border-radius: 20px; background: #fff; color: inherit; text-decoration: none; transition: border-color .2s, box-shadow .2s, transform .2s; }
.education-card:hover { color: inherit; border-color: #a9c8bc; box-shadow: 0 12px 28px #10243a0a; transform: translateY(-3px); }
.education-image { aspect-ratio: 2 / 1; display: grid; place-items: center; overflow: hidden; background: #edf3f4; }
.education-image img { display: block; width: 100%; height: 100%; object-fit: contain; }
.education-image > i { font-size: 44px; color: #69998a; }
.education-body { display: flex; flex: 1; flex-direction: column; padding: 24px; }
.education-body h2 { font-size: 20px; font-weight: 700; letter-spacing: -.5px; line-height: 1.3; margin: 0 0 10px; overflow-wrap: anywhere; }
.education-description { font-size: 14px; color: #637489; line-height: 1.75; margin: 0 0 20px; }
.education-meta { display: flex; align-items: center; flex-wrap: wrap; gap: 12px; margin-top: auto; padding-top: 4px; padding-bottom: 20px; }
.education-levels { display: flex; flex-wrap: wrap; gap: 5px; }
.education-levels span { border-radius: 6px; background: #f1f5f8; padding: 5px 9px; font-size: 11px; font-weight: 600; color: #4c6276; }
.lesson-count { display: inline-flex; align-items: center; gap: 7px; font-size: 12px; color: #637489; margin-left: auto; }
.education-action { display: flex; align-items: center; justify-content: space-between; gap: 12px; border-top: 1px solid #edf0f4; padding-top: 18px; font-size: 14px; font-weight: 650; color: var(--brand-link); }
.education-action > i { display: grid; place-items: center; width: 32px; height: 32px; border-radius: 50%; background: #edf7f2; }
.market-state { display: flex; flex-direction: column; align-items: center; text-align: center; gap: 14px; padding: 64px 24px; background: #fff; border: 1px solid #e0e6ed; border-radius: 20px; color: #637489; }
.market-state > i { font-size: 30px; color: var(--brand-link); }
.market-state h2 { margin: 0; font-size: 20px; color: #10243a; }
.market-state p { margin: 0; font-size: 14px; }
.retry-button { border: 0; border-radius: 10px; padding: 12px 20px; background: var(--brand-link); color: white; font-weight: 600; }
.education-card:focus-visible, .retry-button:focus-visible { outline: 3px solid var(--brand-link); outline-offset: 4px; }
@media (max-width: 575px) {
  .market-grid { grid-template-columns: 1fr; gap: 18px; }
  .education-body { padding: 20px; }
  .education-body h2 { font-size: 21px; }
}
@media (prefers-reduced-motion: reduce) {
  .education-card { transition: none; }
  .education-card:hover { transform: none; }
}
</style>
